export default "__VITE_ASSET__cj9kKBha__"